import { render, staticRenderFns } from "./LoadingImg.vue?vue&type=template&id=bd333fb8&scoped=true&"
import script from "./LoadingImg.vue?vue&type=script&lang=js&"
export * from "./LoadingImg.vue?vue&type=script&lang=js&"
import style0 from "./LoadingImg.vue?vue&type=style&index=0&id=bd333fb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd333fb8",
  null
  
)

export default component.exports